import React, { useState, useEffect } from "react";
import "./NewPatientRegistration.css";

const LabTestStatus = ({ screenAction , triggerSave}) => {

const [isDisabled,setIsDisabled] = useState(true);
const [searchText,setSearchText] = useState("");
const [patients,setPatients] = useState([]);
const [showDropdown,setShowDropdown] = useState(false);

const [tests,setTests] = useState([]);

const initialFormState = {
patient_id:"",
name:"",
test_request_id:""
};

const [formData,setFormData] = useState(initialFormState);


// SEARCH PATIENT
const searchPatients = async (text) => {
  setSearchText(text);

  if (text.length < 2) {
    setPatients([]);
    setShowDropdown(false);
    return;
  }

  const user = JSON.parse(localStorage.getItem("user"));

  const res = await fetch(
    `https://hmsapi.emedhatechnologies.com/master/api/api/lab-requests/search?q=${text}&employee_id=${user.id}`
  );

  const data = await res.json();

  setPatients(data);
  setShowDropdown(true);
};


// SELECT PATIENT
const selectPatient = async(patient)=>{

setFormData({
patient_id:patient.patient_id,
name:patient.name,
test_request_id:""
});

setSearchText(`${patient.name} | ${patient.patient_id}`);
setShowDropdown(false);

// LOAD TEST REQUESTS
const res = await fetch(
  `https://hmsapi.emedhatechnologies.com/master/api/api/lab-request/patient/${patient.patient_id}`
);
const data = await res.json();

setTests(data);

};


// CLEAR FORM
const clearForm = ()=>{

setFormData(initialFormState);
setTests([]);
setIsDisabled(false);

};


// ACTION LISTENER
useEffect(()=>{

if(screenAction==="add"){
clearForm();
}

if(screenAction==="edit"){
setIsDisabled(false);
}

if(screenAction==="view"){
setIsDisabled(true);
}

// if(screenAction==="save"){
// handleSubmit();
// }

if(screenAction==="refresh"){
clearForm();
}

if(screenAction==="print"){
printForm();
}

},[screenAction]);


useEffect(() => {
  if (triggerSave > 0 && screenAction === "save") {
    handleSubmit();
  }
}, [triggerSave]);

// UPDATE SAMPLE STATUS
const updateStatus = (index, value) => {
  setTests(prevTests =>
    prevTests.map((test, i) =>
      i === index ? { ...test, sample_status: value } : test
    )
  );
};


// SAVE
// const handleSubmit = async () => {
//   if (!formData.patient_id) {
//     alert("Patient required");
//     return;
//   }

//   try {
//     for (const test of tests) {
//       const res = await fetch(
//         "https://hmsapi.emedhatechnologies.com/master/api/api/lab-sample-status",
//         {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify({
//             test_ids: [test.test_request_id], // must send array of IDs
//             status: test.sample_status || "Pending", // current status
//           }),
//         }
//       );

//       const result = await res.json();

//       if (!result.success) {
//         console.error(result.message);
//       }
//     }

//     alert("Sample Status Updated");
//   } catch (err) {
//     console.error(err);
//     alert("Network error");
//   }
// };

const handleSubmit = async () => {
  if (!formData.patient_id) {
    alert("Patient required");
    return;
  }

  try {
    const payload = tests.map(test => ({
      test_request_id: test.test_request_id,
      test_id: test.test_id,
      status: test.sample_status || "Pending"
    }));

    const res = await fetch(
      "https://hmsapi.emedhatechnologies.com/master/api/api/lab-sample-status",
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tests: payload }),
      }
    );

    const result = await res.json();

    if (result.success) {
      alert("Sample Status Updated");
    } else {
      alert(result.message || "Update failed");
    }

  } catch (err) {
    console.error(err);
    alert("Network error");
  }
};


// PRINT
const printForm = () => {
  const newWindow = window.open("", "", "width=900,height=700");
  const today = new Date().toLocaleDateString();

  const htmlContent = `
    <html>
      <head>
        <title>Sample Collection Status - ${formData.patient_id}</title>
        <style>
          body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; margin: 0; padding: 40px; }
          
          /* Header Section */
          .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #b8860b; padding-bottom: 10px; margin-bottom: 20px; }
          .hospital-info h1 { margin: 0; color: #2c3e50; font-size: 24px; text-transform: uppercase; }
          .hospital-info p { margin: 2px 0; font-size: 12px; color: #7f8c8d; }
          .report-title { text-align: right; }
          .report-title h2 { margin: 0; color: #b8860b; font-size: 18px; }
          
          /* Section Styling */
          .section-header { background: #fffcf2; padding: 8px 12px; font-weight: bold; font-size: 14px; border-left: 4px solid #b8860b; margin-top: 20px; margin-bottom: 10px; text-transform: uppercase; }
          
          /* Patient Info Grid */
          .patient-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px; margin-bottom: 20px; }
          .info-item { font-size: 13px; display: flex; border-bottom: 1px dotted #ccc; padding: 4px 0; }
          .label { font-weight: 600; width: 150px; color: #555; }
          .value { flex: 1; color: #000; font-weight: 500; }

          /* Test Table */
          table { width: 100%; border-collapse: collapse; margin-top: 10px; font-size: 12px; }
          th { background: #b8860b; color: white; padding: 10px; text-align: left; text-transform: uppercase; }
          td { padding: 10px; border-bottom: 1px solid #eee; }
          
          /* Status Badges */
          .status-collected { color: #27ae60; font-weight: bold; }
          .status-pending { color: #e67e22; font-weight: bold; }
          .status-rejected { color: #e74c3c; font-weight: bold; }

          .footer { margin-top: 50px; font-size: 10px; text-align: center; color: #95a5a6; border-top: 1px solid #eee; padding-top: 10px; }
          .sig-box { margin-top: 60px; display: flex; justify-content: space-between; }
          .sig { border-top: 1px solid #000; width: 200px; text-align: center; padding-top: 5px; font-size: 12px; }

          @media print {
            body { padding: 20px; }
            @page { margin: 0.5cm; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <div class="hospital-info">
            <h1>EMEDHA CARE HOSPITAL</h1>
            <p>123 Medical Park, Health City - 560001</p>
            <p>Phone: +91 98765 43210 | Email: diagnostics@citycare.com</p>
          </div>
          <div class="report-title">
            <h2>SAMPLE COLLECTION LOG</h2>
            <p>Print Date: ${today}</p>
          </div>
        </div>

        <div class="section-header">Patient Information</div>
        <div class="patient-grid">
          <div class="info-item"><span class="label">Patient ID:</span> <span class="value">${formData.patient_id}</span></div>
          <div class="info-item"><span class="label">Patient Name:</span> <span class="value">${formData.name}</span></div>
        </div>

        <div class="section-header">Test List & Collection Status</div>
        <table>
          <thead>
            <tr>
              <th>Request ID</th>
              <th>Test ID</th>
              <th>Test Name</th>
              <th>Category</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            ${tests.map(test => `
              <tr>
                <td>${test.test_request_id}</td>
                <td>${test.test_id}</td>
                <td>${test.test_name}</td>
                <td>${test.category}</td>
                <td class="status-${(test.sample_status || 'Pending').toLowerCase()}">
                  ${test.sample_status || 'Pending'}
                </td>
              </tr>
            `).join('')}
          </tbody>
        </table>

        <div class="sig-box">
          <div class="sig">Phlebotomist Signature</div>
          <div class="sig">Lab Supervisor</div>
        </div>

        <div class="footer">
          This is an internal sample collection log. For "Collected" samples, 
          processing typically takes 4-24 hours depending on the test category.
        </div>
      </body>
    </html>
  `;

  newWindow.document.write(htmlContent);
  newWindow.document.close();
  
  setTimeout(() => {
    newWindow.print();
    newWindow.close();
  }, 500);
};


return(

<div className="registration-container fade-in" id="print-area">

{/* PATIENT SEARCH */}

<div className="patient-search">

<label>Search Patient</label>

<input
type="text"
value={searchText}
placeholder="Search by Name / ID"
onChange={(e)=>searchPatients(e.target.value)}
/>

{showDropdown && patients.length>0 &&(

<div className="patient-dropdown">

{patients.map(p=>(
<div
key={p.patient_id}
className="patient-item"
onClick={()=>selectPatient(p)}
>

{p.name} | {p.patient_id} | {p.test_request_id}

</div>
))}

</div>

)}

</div>
  <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px'  , marginTop: '10px'}}>
<button 
            type="button"
            onClick={() => alert(`Share Lab Status for ${formData.patient_id} via WhatsApp!`)}
            style={{ display: 'flex', alignItems: 'center', gap: '6px', background: '#25D366', color: '#fff', border: 'none', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold', boxShadow: '0 2px 5px rgba(37, 211, 102, 0.3)', height: '36px' }}
            title="Share via WhatsApp"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
            </svg>
            WhatsApp
          </button>
</div>
<form className="luxury-form">

{/* PATIENT DETAILS */}

<div className="form-section-header">
<h3>Patient Details</h3>
</div>

<div className="form-grid">

<div className="input-box">
<label>Patient ID</label>
<input type="text" value={formData.patient_id} readOnly/>
</div>

<div className="input-box">
<label>Name</label>
<input type="text" value={formData.name} readOnly/>
</div>

</div>


{/* TEST STATUS */}

<div className="form-section-header">
<h3>Lab Test Status (Sample Collection)</h3>
</div>

<div className="form-grid full-width">
  <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "center" }}>
    <thead>
      <tr style={{ background: "#f5f5f5" }}>
        <th style={{ padding: "10px" }}>Test Request ID</th>
        <th style={{ padding: "10px" }}>Test ID</th>
        <th style={{ padding: "10px" }}>Test Name</th>
        <th style={{ padding: "10px" }}>Category</th>
        <th style={{ padding: "10px" }}>Fees</th>
        <th style={{ padding: "10px" }}>Sample Status</th>
      </tr>
    </thead>

    <tbody>
      {tests.map((test, index) => (
        <tr key={index}>
          <td style={{ padding: "10px", textAlign: "center" }}>{test.test_request_id}</td>
          <td style={{ padding: "10px", textAlign: "center" }}>{test.test_id}</td>
          <td style={{ padding: "10px", textAlign: "center" }}>{test.test_name}</td>
          <td style={{ padding: "10px", textAlign: "center" }}>{test.category}</td>
          <td style={{ padding: "10px", textAlign: "center" }}>{test.fees}</td>

          <td style={{ padding: "10px", textAlign: "center" }}>
            <select
              value={test.sample_status || "Pending"}
              onChange={(e) => updateStatus(index, e.target.value)}
              disabled={isDisabled}
              style={{ padding: "5px" }}
            >
              <option value="Pending">Pending</option>
              <option value="Collected">Collected</option>
              <option value="Rejected">Rejected</option>
            </select>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>

</form>

</div>

);

};

export default LabTestStatus;